export const INBOX_CHANNELS = {
  voicemail: "voicemail",
  email: "email",
  sms: "sms",
}

function createInboxMessagesPath(extraParams) {
  const params = new URLSearchParams()
  if (extraParams) {
    for (const [key, value] of Object.entries(extraParams)) {
      if (value != null && value !== "") {
        params.set(key, String(value))
      }
    }
  }
  const query = params.toString()
  return query ? `/messages?${query}` : "/messages"
}

export function getInboxReadUrl(notification) {
  if (!notification?.id) {
    return null
  }
  if (notification.channel === INBOX_CHANNELS.sms) {
    return `/crm/api/concierge-sms/inbox/threads/${notification.id}/read/`
  }
  if (notification.channel === INBOX_CHANNELS.email) {
    return `/crm/api/zoho-mail/inbox/threads/${notification.id}/read/`
  }
  if (notification.channel === INBOX_CHANNELS.voicemail) {
    return `/crm/api/inbound-voicemail/inbox/${notification.id}/read/`
  }
  return null
}

export function getInboxMessagesPath(notification) {
  const extra = {}
  if (notification.channel === INBOX_CHANNELS.sms) {
    extra.channel = "sms"
    extra.thread = notification.id
  } else if (notification.channel === INBOX_CHANNELS.voicemail) {
    extra.channel = "voicemail"
    extra.voicemail = notification.id
  } else {
    extra.thread = notification.id
  }
  return createInboxMessagesPath(extra)
}
